class AbstractClass
	@$inject: []
	@_injectAliases: {}

	# Build DI array to later inject to constructor
	@inject: ->
		injectArguments = []

		for argument in arguments
			if _.isObject(argument)
				for alias, injectable of argument
					@_injectAliases[@name] ?= {}
					@_injectAliases[@name][injectable] = alias

					injectArguments.push injectable
			else
				injectArguments.push argument

		@$inject = _.union(@$inject, injectArguments)

	@registerController: (module = null) ->
		module ?= angular.module 'App.Module.Controller'

		@selfRegister module.controller

	@registerService: (module = null) ->
		module ?= angular.module 'App.Service'

		@selfRegister module.service

	@registerRepository: (module = null) ->
		module ?= angular.module 'App.Repository'

		@selfRegister module.service

	@registerComponent: (config, name = null, module = null) ->
		module ?= angular.module 'App.Component'
		name ?= @name.replace(/Component$/, '')

		config.controller ?= @name
		config.controllerAs ?= name

		module.component @name, @

	@selfRegister: (moduleProvider) ->
		moduleProvider(@name, @)

	constructor: ->
		for key, index in @constructor.$inject
			key = @constructor._injectAliases[@constructor.name]?[key] ? key

			@[key] = arguments[index]

	getNewInstance: ->
		injects = []

		for key in @constructor.$inject
			key = @constructor._injectAliases[@constructor.name]?[key] ? key

			injects.push(@[key])

		return new @constructor(...injects)

	__abstract: (name) ->
		throw new Error("#{@constructor.name} must implement method #{name}");
